import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router";
import Dashboard from "../Pages/Dashboard";
import Confirmation from "../Pages/Confirmation";

export default function AppRouter() {
  // Dynamically set the <base> tag based on the current WordPress page URL
  const baseElement = document.createElement("base");
  const currentPath = window.location.pathname;
  baseElement.href = currentPath.endsWith("/")
    ? currentPath
    : `${currentPath}/`;
  document.head.appendChild(baseElement);


  return (
    <BrowserRouter basename={currentPath}>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/confirmation" element={<Confirmation />} />
      </Routes>
    </BrowserRouter>
  );
}
